module.exports = __webpack_public_path__ + "img/pic1.ea259995.png";